import React, {useLayoutEffect, useRef, useState} from "react";
import {Card, Button, Justify} from "tea-component";
import {useAigcIntl} from "@/pages/aigc/utils/utils";
import SvgIcon from "@/pages/home/components/SvgIcon";
import {multipleSegmentGroupContext} from "@/pages/aigc/components/MultipleSegment/MultipleSegment";
import AbnormalPage from "@/pages/datalab/components/AbnormalPage";



export default function MultipleSegmentGroup (props) {
  const { hiddenComponent, loading, error, className="" } = props;
  const heightRef = useRef(null);
  const { Provider } = multipleSegmentGroupContext;
  const {commonFormatMessage} = useAigcIntl("");
  const [expand, setExpand] = useState(false);
  useLayoutEffect(() => {
    // 由于children展开再折叠时, 父元素获取offsetHeight有延迟, 渲染时是上一次的数据, 所以保存一下初始的折叠高度
    heightRef.current && (heightRef.current.initHeight = heightRef.current.offsetHeight);
  }, [loading]);
	
  return (
    <Card>
      <Card.Body className={`aigc-multiple-segement-group ${className}`}>
        <AbnormalPage
          status={loading ? "loading" : (error ? "error" : "normal")}
          style={{backgroundColor: "#ffffff", marginTop: "20px", borderRadio: "8px", height: 84}}
        >
          <Justify
            bottom
            left={(
              <Provider value={{isExpand: expand}}>
                <div style={{height: expand ? "auto" : heightRef?.current?.initHeight, overflow: "hidden"}}>
                  <div ref={heightRef}>
                    {props.children}
                  </div>
                  {hiddenComponent}
                </div>
              </Provider>
            )}
            right={<Button type={"link"} className={"expand-btn"} onClick={() => {setExpand(!expand)}}>{commonFormatMessage(expand ? "retract" : "expand")}&nbsp;<SvgIcon type={expand ? "arrow-up" : "arrow-down"}/></Button>}
          />
        </AbnormalPage>
      </Card.Body>
    </Card>
  );
}